import ShowroomsTable from "./showrooms-table";

export default ShowroomsTable;
